import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const SiteDropDownSMTP = ({
  showUserDropDown,
  navBarCollapsed,
}: {
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
}) => {
  const navigate = useNavigate();

  const {
    siteOptionsSMTP,
    siteDropDownValueSMTP,
    setSiteDropDownValueSMTP,
    setCameraDropDownValueSMTP,
    setUserFiltersSMTP,
    setCameraOptionsSMTP,
    loadingSitesSMTP,
    getCamerasBySiteSMTP,
    getDownloadURLSMTP,
    getSiteTimeZone,
  } = useClipsStore();

  const siteIds = new Map();
  (siteOptionsSMTP || []).forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique names
  (siteOptionsSMTP || []).forEach((object: any) => {
    if (!uniqueNames.has(object.name)) {
      uniqueNames.add(object.name);
      options.push(object.name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 175 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 150 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 240 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 200 };
  }

  return (
    <div key="site_dropdown_smtp">
      <Autocomplete
        value={siteDropDownValueSMTP}
        disablePortal
        options={options}
        loading={loadingSitesSMTP}
        onChange={(event, value: any) => {
          if (value !== null) {
            const id = siteIds.get(value);
            getSiteTimeZone(id, navigate);
            setSiteDropDownValueSMTP(value);
            setCameraDropDownValueSMTP(null);
            getCamerasBySiteSMTP([id], navigate);
            setUserFiltersSMTP((previousState: any) => {
              return {
                ...previousState,
                site_ids: [siteIds.get(value)],
                camera_ids: [],
              };
            });
          } else {
            setSiteDropDownValueSMTP(value);
            setCameraDropDownValueSMTP(null);
            setCameraOptionsSMTP([]);
            setUserFiltersSMTP((previousState: any) => {
              return {
                ...previousState,
                site_ids: [],
                camera_ids: [],
              };
            });
          }
          getDownloadURLSMTP(navigate);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSitesSMTP ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            helperText="*Required"
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
